/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Ethics_Desc6Inputs */

const en_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt-aware, rate-limit-respecting, and account-safe extraction that won't put your operation in the gray zone.`)
};

const ar_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سكرابينغ يراعي robots.txt ويحترم حدود المعدل وآمن للحساب ولن يضع عملك في المنطقة الرمادية.`)
};

const bn_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt-সচেতন, রেট-লিমিট-সম্মানী ও অ্যাকাউন্ট-সেফ এক্সট্রাকশন, আপনার অপারেশনকে গ্রে জোনে ফেলে না।`)
};

const de_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt-konforme, ratenlimitfreundliche und kontosichere Extraktion, die Ihren Betrieb nicht in die Grauzone bringt.`)
};

const es_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracción segura para la cuenta, compatible con robots.txt, que respeta el límite de velocidad y que no pondrá su operación en la zona gris.`)
};

const fr_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction compatible Robots.txt, respectant la limite de débit et sécurisée pour le compte, qui ne mettra pas votre opération dans la zone grise.`)
};

const pt_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extração com reconhecimento de Robots.txt, respeitosa de limite de taxa e segura para conta que não colocará sua operação na zona cinzenta.`)
};

const zh_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt 感知、速率限制和帐户安全提取不会将您的操作置于灰色地带。`)
};

const tr_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operasyonunuzu gri bölgeye sokmayan Robots.txt uyumlu, hız sınırına saygılı ve hesap açısından güvenli çıkarma.`)
};

const ru_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечение с поддержкой Robots.txt, ограничением скорости и безопасностью учетной записи, которое не поместит вашу операцию в серую зону.`)
};

const pl_svc_web_scraping_ethics_desc6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstrakcja świadoma Robots.txt, szanująca limity i bezpieczna dla konta, twoje działanie nie ląduje w szarej strefie.`)
};

/**
* | output |
* | --- |
* | "Robots.txt-aware, rate-limit-respecting, and account-safe extraction that won't put your operation in the gray zone." |
*
* @param {Svc_Web_Scraping_Ethics_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_ethics_desc6 = /** @type {((inputs?: Svc_Web_Scraping_Ethics_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Ethics_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_ethics_desc6(inputs)
	if (locale === "bn") return bn_svc_web_scraping_ethics_desc6(inputs)
	if (locale === "de") return de_svc_web_scraping_ethics_desc6(inputs)
	if (locale === "es") return es_svc_web_scraping_ethics_desc6(inputs)
	if (locale === "fr") return fr_svc_web_scraping_ethics_desc6(inputs)
	if (locale === "pt") return pt_svc_web_scraping_ethics_desc6(inputs)
	if (locale === "zh") return zh_svc_web_scraping_ethics_desc6(inputs)
	if (locale === "tr") return tr_svc_web_scraping_ethics_desc6(inputs)
	if (locale === "ru") return ru_svc_web_scraping_ethics_desc6(inputs)
	if (locale === "pl") return pl_svc_web_scraping_ethics_desc6(inputs)
	return en_svc_web_scraping_ethics_desc6(inputs)
});
export { svc_web_scraping_ethics_desc6 as "svc_web-scraping_ETHICS_desc" }